export enum ButtonTypesEnum {
  Primary = 1,
  Secondary,
  Tertiary,
  Link,
  LinkSecondary,
  Discover,
}
